import moment from 'moment';

export default moment.months().map((name, index) => ({
  description: name,
  key: `0${index + 1}`.slice(-2),
}));
